const SERVICE_ICON_COLOR_BY_TYPE: Record<string, string> = {
  accommodation: "#fd0c6f",
  hotel: "#fd0c6f",
  activity: "#f09d57",
  excursion: "#f09d57",
  transfer: "#57c68a",
  transport: "#3ba78b",
  flight: "#4f8cff",
  train: "#7a5af8",
  ferry: "#2f9ed8",
  meal: "#e2c92e",
  restaurant: "#e2c92e",
  ticket: "#f97316",
  guide: "#14b8a6",
  stage_information: "#e11d48",
  general_information: "#64748b",
};

const SERVICE_ICON_COLOR_BY_KEYWORD: Array<{ keywords: string[]; color: string }> = [
  { keywords: ["hotel", "accommodation", "resort", "room", "hostel", "camp"], color: "#fd0c6f" },
  { keywords: ["activity", "excursion", "experience", "tour", "adventure"], color: "#f09d57" },
  { keywords: ["transfer", "taxi", "shuttle", "pickup", "drop"], color: "#57c68a" },
  { keywords: ["transport", "vehicle", "car", "van", "coach", "bus"], color: "#3ba78b" },
  { keywords: ["flight", "plane", "airline", "air"], color: "#4f8cff" },
  { keywords: ["train", "rail"], color: "#7a5af8" },
  { keywords: ["ferry", "boat", "ship", "cruise"], color: "#2f9ed8" },
  { keywords: ["meal", "food", "restaurant", "dinner", "lunch", "breakfast"], color: "#e2c92e" },
  { keywords: ["ticket", "entry", "pass"], color: "#f97316" },
  { keywords: ["guide", "leader"], color: "#14b8a6" },
  { keywords: ["stage_information", "stage"], color: "#e11d48" },
  { keywords: ["general_information", "general", "info"], color: "#64748b" },
];

const DEFAULT_SERVICE_ICON_COLOR = "#222422";

export const getServiceIconColor = (type?: string): string => {
  if (!type) {
    return DEFAULT_SERVICE_ICON_COLOR;
  }

  const normalizedType = String(type).toLowerCase();
  const exactMatch = SERVICE_ICON_COLOR_BY_TYPE[normalizedType];

  if (exactMatch) {
    return exactMatch;
  }

  const keywordMatch = SERVICE_ICON_COLOR_BY_KEYWORD.find(({ keywords }) =>
    keywords.some((keyword) => normalizedType.includes(keyword))
  );

  return keywordMatch?.color || DEFAULT_SERVICE_ICON_COLOR;
};
